export default function getAgeClasses() {
    return [
        {value: "49", label: "Prior to Age 50"},
        {value: "59", label: "Age 50 - 59"},
        {value: "64", label: "Age 60 - 64"},
        {value: "70", label: "Age 65 or older"}
    ];
}